import type { NavItem, ThemeConfig } from "./types";

export const isItemVisible = (item: NavItem): boolean =>
  item.visible?.isVisible !== false;

export const filterVisibleItems = (items: NavItem[] = []): NavItem[] =>
  items.filter(isItemVisible).map((item) => ({
    ...item,
    children: item.children ? filterVisibleItems(item.children) : undefined,
    items: item.items ? filterVisibleItems(item.items) : undefined
  }));

export const sortByPosition = (items: NavItem[]): NavItem[] =>
  [...items].sort((a, b) => (a.position ?? 0) - (b.position ?? 0));

export const themeToCssVariables = (
  theme: ThemeConfig
): Record<string, string> => ({
  "--navbar-bg": theme.backgroundColor,
  "--navbar-text": theme.textColor,
  "--navbar-text-active": theme.activeTextColor,
  "--navbar-text-hover": theme.hoverTextColor,
  "--navbar-border": theme.borderColor
});

export const getInitials = (name?: string): string => {
  if (!name?.trim()) return "";
  return name
    .trim()
    .split(/\s+/)
    .map((part) => part[0])
    .join("")
    .slice(0, 2)
    .toUpperCase();
};
